let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1awGT")).then(() => parcelRequire('6ADIT'));